import FeatureRouteGuard from "./FeatureRouteGuard";

const MonitoringRouteGuard = ({ children }: { children: React.ReactNode }) => (
  <FeatureRouteGuard flag="monitoring_enabled" permission="monitoring.view">
    {children}
  </FeatureRouteGuard>
);

export default MonitoringRouteGuard;
